module.exports = __webpack_public_path__ + "img/mas_buscados_5.d51f0c6b.png";